import { ClientNotExistError } from '@cosmos-kit/core';
import { StationExtension } from './extension';
export const getStationFromExtension = async () => {
    if (typeof window === 'undefined') {
        return void 0;
    }
    if (!window.isStationExtensionAvailable) {
        throw ClientNotExistError;
    }
    const stationExtension = new StationExtension();
    await stationExtension.init();
    return stationExtension;
};
//# sourceMappingURL=utils.js.map